import React, { FC, ReactNode } from "react";
import { HiPlus } from "react-icons/hi2";

/**
 * Empty box of the Client portal tab's inner tabs (owner's design 2026-10-28):
 * dashed border, round purple icon, title, one line of help and an optional
 * outline button.
 */
export const PortalEmptyState: FC<{
  icon: ReactNode;
  title: string;
  text: string;
  actionLabel?: string;
  onAction?: () => void;
  actionDisabled?: boolean;
  actionTitle?: string;
  testId?: string;
}> = ({
  icon,
  title,
  text,
  actionLabel,
  onAction,
  actionDisabled,
  actionTitle,
  testId,
}) => (
  <div
    data-testid={testId}
    className={
      "flex min-h-[216px] flex-col items-center justify-center rounded-[12px] border border-dashed border-[#DCE2EA] px-6 py-10 text-center"
    }>
    <span
      className={
        "flex h-[54px] w-[54px] items-center justify-center rounded-full bg-[#F0EDFF] text-[#7C5CFC]"
      }>
      {icon}
    </span>
    <div className={"mt-4 text-[15px] font-bold text-[#1F2433]"}>{title}</div>
    <p
      className={
        "mx-auto mt-2 max-w-[400px] text-[13px] font-medium text-[#8A90A2]"
      }>
      {text}
    </p>
    {actionLabel && onAction && (
      <button
        type={"button"}
        onClick={onAction}
        disabled={actionDisabled}
        title={actionTitle}
        className={
          "mt-4 inline-flex h-9 items-center gap-1.5 rounded-[8px] border border-[#DCE2EA] bg-white px-4 text-[13px] font-bold text-[#3A4256] hover:bg-[#F7F8FA] disabled:cursor-not-allowed disabled:opacity-50"
        }>
        <HiPlus size={14} /> {actionLabel}
      </button>
    )}
  </div>
);
